/*
 * mini-series-referencias.js
 *
 * §02 accordion UX: when a reference is expanded, scroll it to the top of
 * the viewport so the just-opened panel is immediately in view (the native
 * <details name> exclusive accordion otherwise leaves the viewport where it
 * was, losing the opened content below the fold).
 *
 * Respects scroll-margin-top (set on .ms-ref-acc__item) so the sticky header
 * doesn't cover the summary. Idempotent.
 */
(function () {
  if (window.__msReferencias) return;
  window.__msReferencias = true;

  function bind(item) {
    item.addEventListener('toggle', function () {
      if (!item.open) return;
      // Let the exclusive-accordion layout settle (the previously open panel
      // collapses) before scrolling to the final position.
      requestAnimationFrame(function () {
        item.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  function init() {
    var items = document.querySelectorAll('.ms-ref-acc__item');
    Array.prototype.forEach.call(items, bind);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
